// import { gql, useMutation } from "@apollo/client";

import gql from "graphql-tag";

// export const useUpdateMasjidStatus = () => {
//   const [updateMasjidStatus, { loading, error, data }] = useMutation(
//     UPDATE_MASJID_STATUS
//   );

//   const updateStatus = async ({
//     masjidId,
//     description,
//     status,
//     freeze,
//   }: any) => {
//     try {
//       const response = await updateMasjidStatus({
//         variables: {
//           input: {
//             masjidId,
//             description,
//             status,
//           },
//           freeze,
//         },
//       });
//       return response.data.updateMasjidStatus; // You can modify this based on what you need from the response
//     } catch (err) {
//       console.error("Error updating masjid status:", err);
//       throw err;
//     }
//   };

//   return {
//     updateStatus,
//     loading,
//     error,
//     data,
//   };
// };

export const UPDATE_USER_STATUS = gql`
  mutation UpdateUserStatus($input: UserLedgerInput!, $freeze: Boolean!) {
    updateUserStatus(input: $input, freeze: $freeze) {
      _id
      userId
      description
      status
      adminId
      createdAt
      updatedAt
    }
  }
`;

export const USER_MASJID_ACTION = gql`
  mutation UserMasjidAction(
    $userId: String!
    $masjidId: String!
    $action: String!
  ) {
    userMasjidAction(userId: $userId, masjidId: $masjidId, action: $action)
  }
`;

export const SWITCH_ROLE = gql`
  mutation SwitchRole($input: SwitchRoleInput!) {
    switchRole(input: $input) {
      _id
      userId
      description
      status
      adminId
      createdAt
      updatedAt
    }
  }
`;

export const CHANGE_EMAIL = gql`
  mutation ChangeEmail($input: ChangeEmailInput!) {
    changeEmail(input: $input) {
      status
      description
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_USER_BIOMETRIC = gql`
  mutation UpdateUserBiometric($input: UpdateUserBiometricInput!) {
    updateUserBiometricDetails(input: $input) {
      status
      description
      createdAt
      updatedAt
    }
  }
`;

// Archive mutations based on the provided API schema
export const DELETE_USER = gql`
  mutation DeleteUser($input: DeleteUserInput!) {
    deleteUser(input: $input) {
      _id
      archiveType
      originalId
      originalType
      deletedData
      deletedBy
      deletedByEmail
      deletedByRole
      reason
      description
      deletedAt
      restoredAt
      restoredBy
      restoredByEmail
      isRestored
      metadata
    }
  }
`;

export const DELETE_ENTITY = gql`
  mutation DeleteEntity($input: DeleteEntityInput!) {
    deleteEntity(input: $input) {
      _id
      archiveType
      originalId
      originalType
      deletedData
      deletedBy
      deletedByEmail
      deletedByRole
      reason
      description
      deletedAt
      restoredAt
      restoredBy
      restoredByEmail
      isRestored
      metadata
    }
  }
`;

export const RESTORE_ARCHIVE = gql`
  mutation RestoreArchive($input: RestoreArchiveInput!) {
    restoreArchive(input: $input) {
      _id
      archiveType
      originalId
      originalType
      deletedData
      deletedBy
      deletedByEmail
      deletedByRole
      reason
      description
      deletedAt
      restoredAt
      restoredBy
      restoredByEmail
      isRestored
      metadata
    }
  }
`;

export const MIGRATE_ENTITY = gql`
  mutation MigrateEntity($input: EntityMigrationInputV2!) {
    migrateEntityV2(input: $input) {
      _id
      sourceEntityId
      sourceEntityType
      targetEntityType
      description
      adminId
      status
      createdAt
      updatedAt
    }
  }
`;

export const APPROVE_ENTITY_MIGRATION = gql`
  mutation ApproveEntityMigration($id: String!) {
    approveEntityMigration(id: $id) {
      _id
      sourceEntityId
      sourceEntityType
      targetEntityType
      description
      adminId
      status
      createdAt
      updatedAt
    }
  }
`;
